module.exports = __webpack_public_path__ + "static/media/fallback-person-image.5d42c799.png";